import { useEffect } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { RETURN_AFTER_SIGN_IN_KEY } from '../services/api'

/** The product page on splashtop.com, where a signed-out visitor to the portal's root belongs. */
export const PRODUCT_PAGE_URL = 'https://www.splashtop.com/agentic-packr?topnav=agentic-packr'

/** The product page with the visitor's own query (campaign tags) carried over. */
export function productPageUrl(search: string): string {
  const extra = new URLSearchParams(search)
  const url = new URL(PRODUCT_PAGE_URL)
  extra.forEach((value, key) => {
    if (!url.searchParams.has(key)) url.searchParams.append(key, value)
  })
  return url.toString()
}

function sessionJustEnded(): boolean {
  try {
    return window.sessionStorage.getItem(RETURN_AFTER_SIGN_IN_KEY) !== null
  } catch {
    return false
  }
}

/**
 * What a signed-out visitor sees inside the app: the root goes to the product page, any other
 * page goes to sign-in and comes back once signed in. A session that has just expired goes to
 * sign-in even from the root, since that visitor was using the app.
 */
export default function SignedOutRedirect() {
  const { pathname, search } = useLocation()
  const isRoot = pathname === '/' && !sessionJustEnded()

  useEffect(() => {
    // Sign-out moves to /login and ends the session in the same tick, and the session store can
    // render this route before the router has caught up; the address bar has already moved on.
    if (isRoot && window.location.pathname === '/') window.location.replace(productPageUrl(search))
  }, [isRoot, search])

  if (isRoot) return null
  try {
    window.sessionStorage.setItem(RETURN_AFTER_SIGN_IN_KEY, pathname + search)
  } catch {
    // Without storage the visitor lands on the default page after signing in.
  }
  return <Navigate to="/login" replace />
}
